import React from 'react';
import { MotionConfig } from 'framer-motion';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BonusesSection } from './components/BonusesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Testimonials } from './components/Testimonials';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
import { useMetaPixel } from './hooks/useMetaPixel';
import { META_PIXEL_ID } from './data/content';
export function App() {
  useMetaPixel(META_PIXEL_ID);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="23vkuoemiy5k6">
      <div className="min-h-screen w-full bg-crudo font-sans text-marron selection:bg-terracota selection:text-crudo" data-id="element-1" data-mp="23ujl6el5pr4k">
        <noscript data-id="element-2" data-mp="3ijpet5g4t7bv">
          <img height="1" width="1" style={{
          display: 'none'
        }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-3" data-mp="3ii4ppvcl6gle" />
        </noscript>

        <Hero data-id="element-4" data-mp="4wvhonpuufq" />
        <main data-id="element-5" data-mp="4n7g6m8exco">
          <ProblemSection data-id="element-6" data-mp="56m9egl55mh" />
          <SolutionSection data-id="element-7" data-mp="2zl3bdjx5744s" />
          <BonusesSection data-id="element-8" data-mp="2zlv84y2h77wn" />
          <BenefitsSection data-id="element-9" data-mp="2zmo4d53t6f0j" />
          <OfferSection data-id="element-10" data-mp="2zng0ch1bierc" />
          <GuaranteeSection data-id="element-11" data-mp="33m5be2yvvk7t" />
          <Testimonials data-id="element-12" data-mp="33ngf62sbwryx" />
          <FAQSection data-id="element-13" data-mp="33myix65o2dr0" />
          <FinalCTA data-id="element-14" data-mp="38lro8basuyg3" />
        </main>
        <Footer data-id="element-15" data-mp="38kqcs5pvg9xu" />
        <PurchasePopup data-id="element-16" data-mp="38l00tnrcw70w" />
      </div>
    </MotionConfig>;
}